import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';
import { getFolderContentsQueryKey } from './useFetchFolderContents';

export const useGetRootFolder = ({
  enabled = true,
  page = 1,
  perPage = DATA_GRID_LAZY_PAGE_SIZE,
}: { enabled?: boolean; page?: number; perPage?: number } = {}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { data, isLoading, error } = useQuery({
    queryKey: getFolderContentsQueryKey({ tenantId, page, perPage }),
    queryFn: () => api.folders.listRootContents({ tenantId, contentType: 'all', page, perPage }),
    select: response => response.data,
    enabled: enabled && !!tenantId,
  });

  return {
    folder: data,
    totalCount: data?.pageData?.total,
    isEmpty: data?.pageData?.total === 0,
    isLoading,
    error,
  };
};
